import { MAX_VALUES } from "../../constants/NoteValues";
import { TabHeader } from "./TabHeader";
import "./styles.css";

export function DesktopTabContent({
  noteStates,
  noteTotal,
  isAdmin,
  handleNoteChange,
}) {
  const NoteInput = ({ note, index }) => (
    <input
      type="number"
      className="w-full min-w-8 min-h-8 text-center border rounded-md"
      value={note?.value || ""}
      onChange={(e) => handleNoteChange(note.module, e.target.value, index)}
      disabled={noteStates[index].exist && !isAdmin}
      min={0}
    />
  );

  return (
    <table className="min-w-full text-center border-collapse">
      <thead className="bg-white">
        <tr>
          {noteStates.map((n, i) => (
            <TabHeader
              key={i}
              index={i}
              label={n.moduleName}
              maxValue={MAX_VALUES[n.module]}
            />
          ))}
          <TabHeader label="Total" />
        </tr>
      </thead>
      <tbody>
        <tr>
          {noteStates.map((n, i) => (
            <td key={i} className="border p-2">
              <NoteInput note={n} index={i} />
            </td>
          ))}
          <td className="border p-2">
            <input
              type="number"
              className="w-full min-w-8 min-h-8 text-center"
              value={noteTotal}
              readOnly
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
